window.SMTX.PardotTracker = (function () {
  

  function track(formHandler, data){
    var formUrl = "/pardot/form_handler.php?path=" + formHandler;
    $.ajax({
      method: "POST",
      timeout: 0,
      url: formUrl,
      data: data,
      success: onFormSuccess,
      error: onFormError
    });
  }

  function onFormSuccess(response){
   log('Success' + response);
  }
  function onFormError(response){
   log('Error' + response);
  }

  return {
    track: track
  };

})();
